/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class AccountListController extends ListController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log, accountService,
        companyService, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.accountService = accountService;
        this.companyService = companyService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'AccountList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.paging.sort = 'username';
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.companyFilter = Filter.equalFilterEmpty('company.id', 'model.company.company', 'SELECT', []);

        this.filters.push(
            Filter.emptyLikeFilter('username', 'model.account.username'),
            this.companyFilter,
            Filter.emptyLikeFilter('email', 'model.account.email'),
            Filter.booleanFilter('enabled', 'model.account.enabled'),
            Filter.booleanFilter('system', 'model.account.system', false)
        );
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterCompanies();
    }

    /**
     * Gets the list of companies.
     *
     * @return {Object[]} Promise providing an array of companies.
     */
    getFilterCompanies() {
        return this.filterService.getFilterOptions(this.companyService, this.companyFilter);
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.account.create', 'images/svg/add.svg', 'gmao.organization.account.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Reloads the list of accounts.
     *
     * @return {Promise} A promise providing the list of accounts.
     */
    reload() {
        return this.handleRestServiceCall(
            this.accountService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }
}

export const accountListComponent = {
    template: require('./account-list.html'),
    controller: AccountListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/AccountList.js